import { StyleSheet } from 'aphrodite';
import { brandPrimary, inputBorderColor } from '../../../../styles/colors';
import { THEME } from '../../../../components-v2/Theme/theme';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	trigger: {
		height: 42,
		width: '100%',
		boxSizing: 'border-box',
		borderRadius: 8,
		border: `1px solid ${inputBorderColor}`,
		backgroundColor: colors.background.light,
		fontSize: 13,
		padding: 10,
	},
	content: {
		minWidth: 200,
	},
	resetItem: {
		color: brandPrimary,
		fontSize: '0.75rem',
	},
});
